import { type FC, Fragment } from 'react'
import { KTSVG } from '_metronic/helpers'
import { ClientSideTable } from 'Presentation/Components/Table'
import useViewModel from './ViewModel'

const ProjectSiteSupervisorView: FC = () => {
  const { data, columns, onAssignSiteSupervisor } = useViewModel()

  return (
    <Fragment>
      {' '}
      <div className='card'>
        <div className='card-header'>
          <div className='card-title'></div>
          <div className='card-toolbar'>
            <button
              className='btn btn-sm btn-primary me-2 cursor-pointer'
              onClick={onAssignSiteSupervisor}>
              <KTSVG
                path='/media/icons/duotune/arrows/arr075.svg'
                svgClassName='svg-icon-1x svg-primary'
              />
              <span>เพิ่มผู้ช่วย (Site Supervisor)</span>
            </button>
          </div>
        </div>

        <div className='card-body px-0'>
          <ClientSideTable isGrey pagination columns={columns} data={data} items_per_page={10} />
        </div>
      </div>
    </Fragment>
  )
}

export default ProjectSiteSupervisorView
